import { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Loader2, Lock } from "lucide-react";
import { API, LOGO } from "@/lib/site";
import useSeo from "@/hooks/useSeo";

export default function AdminLogin() {
  const nav = useNavigate();
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState({ email: "", password: "" });
  useSeo({ title: "Admin — Orrbbit" });

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await axios.post(`${API}/auth/login`, form);
      localStorage.setItem("orrbbit_admin_token", res.data.access_token);
      toast.success("Signed in");
      nav("/admin");
    } catch (err) {
      const d = err.response?.data?.detail;
      toast.error("Sign in failed", { description: typeof d === "string" ? d : "Check your credentials." });
    } finally {
      setLoading(false);
    }
  };

  const field = "w-full rounded-xl border border-input bg-white px-4 py-3 text-navy focus:border-teal focus:outline-none focus:ring-2 focus:ring-teal/30";

  return (
    <div className="flex min-h-screen items-center justify-center px-5" data-testid="admin-login-page">
      <div className="w-full max-w-sm rounded-3xl border border-border bg-white p-8 shadow-card">
        <img src={LOGO} alt="Orrbbit" className="h-8 w-auto" />
        <div className="mt-6 flex items-center gap-2 text-navy"><Lock size={18} className="text-teal" /><h1 className="font-heading text-xl font-semibold">Staff sign in</h1></div>
        <p className="mt-1 text-sm text-bodygrey">Authorised staff only.</p>
        <form onSubmit={submit} className="mt-6 space-y-4" data-testid="admin-login-form">
          <input type="email" required data-testid="admin-email-input" className={field} placeholder="Email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} />
          <input type="password" required data-testid="admin-password-input" className={field} placeholder="Password" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} />
          <button type="submit" disabled={loading} data-testid="admin-login-btn" className="inline-flex w-full items-center justify-center gap-2 rounded-full bg-teal px-6 py-3 font-semibold text-white transition-transform hover:scale-[1.02] disabled:opacity-60">
            {loading ? <Loader2 className="animate-spin" size={18} /> : null}{loading ? "Signing in..." : "Sign in"}
          </button>
        </form>
      </div>
    </div>
  );
}

